import React from 'react';
import { SkeletonRegistryCategory } from '../../../registry/skeleton/SkeletonRegistryCategory';
import { SkeletonRegistryItem } from '../../../registry/skeleton/SkeletonRegistryItem';
import { QuestionTypeName } from '../../../classes/learnware/LearnwareEnums';
import { QuestionSortable_ } from '../components/QuestionSortable_';
export class SkeletonsSortable extends SkeletonRegistryCategory {
    label = 'Question Sortable';
    constructor(parent) {
        super(parent);
        super.init();
    }
    DefaultSortableStructure = () => new SkeletonRegistryItem({
        jsx: ({ questionSortable }) => {
            if (questionSortable.questionType !== QuestionTypeName.Sortable)
                return null;
            return React.createElement(QuestionSortable_, { question: questionSortable });
        },
    });
    SortableStructureDroppables2ToNGrouped = () => new SkeletonRegistryItem({
        jsx: ({ questionSortable }) => {
            if (questionSortable.questionType !== QuestionTypeName.Sortable)
                return null;
            return React.createElement(QuestionSortable_, { question: questionSortable, layout: "droppables2ToNGrouped" });
        },
    });
}
